export default mainHeader => {

    const btnMenuToggle = mainHeader.querySelector('.js-menuMobile_toggle');
    
    const mainHeader__height = mainHeader.querySelector('.mainHeader__inner').offsetHeight;

    let scrollY;
    let scrollY__old = 0;
        
    const handleScroll = () => {
        scrollY = window.pageYOffset || window.scrollY;

        if (scrollY__old < scrollY && scrollY > mainHeader__height) {
            mainHeader.classList.remove('show');
        } else if (scrollY__old > scrollY) {
            mainHeader.classList.add('show');
        }

        mainHeader.classList[(scrollY > (mainHeader__height + 20)) ? 'add' : 'remove']('bg');

        scrollY__old = scrollY;
    }
    
    btnMenuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        mainHeader.classList.toggle('navOpen');
        document.body.classList.toggle('oh');
    });

    window.addEventListener('scroll', handleScroll);
    handleScroll()
};
